// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"element-list_wrapper__2KY6N","active":"element-list_active__1Fa0S","deleteIcon":"element-list_deleteIcon__3rRy1"};